import { getElements } from './CanvasUtil';
import { createSaveEvent } from './createSaveEvent';
import { saveCanvasEvent } from './canvasApi';

export const DEFAULT_ZOOM_FOR_FOCUSING_VIEWPORT = 1.25;

// Grabs the size of the canvas
export const getCanvasSizeInfo = () => {
  let res = {
    width: 0,
    height: 0,
  };

  try {
    let info = document.getElementsByClassName('react-flow__pane')[0].getBoundingClientRect();
    if (info.width && info.height) res = info;
    return res;
  } catch (e) {
    return res;
  }
};

/**
 *
 * @param {*} targetPosition => The position of the component we want to focus on
 * @param {*} xOffset => This dictates how far left/right the viewport will move
 * @param {*} rfInstance => The react flow instance
 * @param {*} reuseZoom => true/false on whether to use the previous canvas zoom or use the default
 * @param {*} projectId => The project's id
 * @param {*} remainingCanvasWidthAsDecimal => Is a decimal representation of the remaining width of the canvas
 *                                             (i.e: 100% - 40% (PANE_WIDTH) = 0.6)
 * @returns
 */
export const setPositionInCanvasView = async (
  targetViewport,
  xOffset,
  rfInstance,
  reuseZoom,
  projectId,
  remainingCanvasWidthAsDecimal,
  targetZoom
) => {
  if (!rfInstance || !targetViewport) return;

  let info = getCanvasSizeInfo();

  // Set defaults
  if (!xOffset) xOffset = -100;
  if (!remainingCanvasWidthAsDecimal) remainingCanvasWidthAsDecimal = 0.6;

  let zoom = targetZoom ? targetZoom : DEFAULT_ZOOM_FOR_FOCUSING_VIEWPORT;

  // If we're re-using the zoom, set the zoom from the react flow instance
  if (reuseZoom) zoom = rfInstance.toObject().viewport.zoom;

  // Calculates the viewport center
  const viewPortCenterX = info.width / 2;
  const viewPortCenterY = info.height / 2;

  // Calculate the new viewport center considering the node's coordinates
  const newViewPortCenterX = viewPortCenterX - targetViewport.x * zoom;
  const newViewPortCenterY = viewPortCenterY - targetViewport.y * zoom;

  // Calculate the far left X position
  const farLeftX = newViewPortCenterX - viewPortCenterX;

  // Calculate the first quadrant line of the canvas
  let canvasQuarter = (remainingCanvasWidthAsDecimal * info.width) / 2;

  const newViewport = {
    x: farLeftX + canvasQuarter + xOffset,
    y: newViewPortCenterY,
    zoom: zoom,
  };

  rfInstance.setViewport(
    { x: newViewport.x, y: newViewport.y, zoom: newViewport.zoom },
    { duration: 1000 }
  );

  // If a project id is given, we want to save the viewport in the backend
  if (projectId) await saveViewport(newViewport, rfInstance, projectId);
};

const saveViewport = async (viewport, reactFlowInstance, projectId) => {
  let saveEvent = createSaveEvent(
    'SAVE_VIEWPORT',
    projectId,
    viewport,
    getElements(reactFlowInstance),
    { projectId: projectId }
  );

  // Send the save viewport event
  const json = await saveCanvasEvent(projectId, saveEvent);
};
